<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="登录日志">
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <el-table-column type="selection" width="55" v-if="isShowCheckBox"></el-table-column>
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                    <el-table-column  label="时间" prop="date"></el-table-column>
                    <el-table-column  label="IP" prop="ip"></el-table-column>
                    <el-table-column  label="地区" prop="location"></el-table-column>
                    <el-table-column  label="登录方式" prop="type_string"></el-table-column>
                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :total="total" :page-size="perPage" @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { parseTime } from '@/utils'
    import { getLoginLog } from '@/service/user'
    import {getUserInfo} from '@/utils/auth'
    export default {
        name: 'LoginLog',
        data () {
            return {
                isShowCheckBox: false, // 是否显示多选框
                isLoading: false, // 是否显示loading加载
                list: [],
                checkList: [], // 当前选中下标列表
                currentPage: 1,
                perPage: 10,
                total:0
            }
        },
        mounted () {
            this.initData()
        },
        methods: {
            /** 初始化数据请求 */
            async initData () {
                let user = JSON.parse(getUserInfo())
                let query = {
                    page : this.currentPage,
                    per_page: this.perPage
                }
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                // 模拟fetch请求数据....
                await getLoginLog(user.id, query).then((data) => {
                    this.total= data.total
                    this.perPage = 10
                    let listData = data.data
                    for (let i in listData) {
                        listData[i].date = parseTime(listData[i].login_time)
                        switch (listData[i].type) {
                            case 1:
                                listData[i].type_string = 'PC登录';
                                break;
                            case 2:
                                listData[i].type_string = 'M登录';
                                break;
                            default:
                                listData[i].type_string = '';
                                break;
                        }
                    }
                    this.list = listData
                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            currentChange (index) {
                this.currentPage=index
                this.initData()
            }
        }
    }
</script>
